module.exports = __webpack_public_path__ + "img/classroomteacherform2.0fff7810.jpg";